import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import '@fontsource-variable/inter/opsz.css';
import '@fontsource-variable/jetbrains-mono';
import '@fontsource-variable/bricolage-grotesque/opsz.css';
import './styles/tokens.css';
import './styles/base.css';
import './styles/components.css';
import './styles/layout.css';
import './styles/auth.css';
import './styles/problems.css';
import './styles/workspace.css';
import './styles/contests.css';
import './styles/profile.css';
import './styles/blog.css';
import './styles/tracker.css';
import './styles/courses.css';
import App from './App';
import { TenantProvider } from './tenant/TenantProvider';
import { ThemeProvider } from './theme/ThemeProvider';
import { ToastProvider } from './ui/Toast';

const router = createBrowserRouter([{ path: '*', element: <App /> }]);

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ThemeProvider>
      <TenantProvider>
        <ToastProvider>
          <RouterProvider router={router} />
        </ToastProvider>
      </TenantProvider>
    </ThemeProvider>
  </React.StrictMode>
);
